import * as actionTypes from "../actionTypes";
import axios from "axios";
import { config } from "../../../config/config";

function yyyyMMddHHiiSS(date) {
  function pad(number) {
    if (number < 10) {
      return "0" + number;
    }
    return number;
  }

  return (
    date.getFullYear() +
    pad(date.getMonth() + 1) +
    pad(date.getDate()) +
    pad(date.getHours()) +
    pad(date.getMinutes()) +
    pad(date.getSeconds())
  );
}

const now = new Date();

const fileExportSuccess = (fileexport) => {
  return {
    fileexport,
    type: actionTypes.FILE_EXPORT_SUCCESS,
  };
};

export const onDashboardExport = (startDate, endDate) => {
  let fileUrl;

  if (startDate && !endDate) {
    fileUrl = `${config.export}?startDate=${startDate}`;
  } else if (endDate && !startDate) {
    fileUrl = `${config.export}?endDate=${endDate}`;
  } else if (startDate && endDate) {
    fileUrl = `${config.export}?startDate=${startDate}&endDate=${endDate}`;
  } else {
    fileUrl = `${config.export}`;
  }

  return async (dispatch) => {
    axios({
      url: fileUrl,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `nutriasia-weekly-report-${yyyyMMddHHiiSS(now)}.xlsx`
      );
      document.body.appendChild(link);
      link.click();

      dispatch(fileExportSuccess(response.data));
    });
  };
};

export const onTransactionsExport = (startDate, endDate, text, status) => {
  let fileUrl;

  if (!startDate && !endDate && text && status !== "any") {
    fileUrl = `${config.transactions}/export?text=${text}&status=${status}`;
  } else if (!startDate && !endDate && text && status === "any") {
    fileUrl = `${config.transactions}/export?text=${text}`;
  } else if (!startDate && !endDate && !text && status !== "any") {
    fileUrl = `${config.transactions}/export?status=${status}`;
  } else if (startDate && endDate && text && status !== "any") {
    fileUrl = `${config.transactions}/export?startDate=${startDate}&endDate=${endDate}&text=${text}&status=${status}`;
  } else if (startDate && endDate && text && status === "any") {
    fileUrl = `${config.transactions}/export?startDate=${startDate}&endDate=${endDate}&text=${text}`;
  } else if (startDate && endDate && status !== "any") {
    fileUrl = `${config.transactions}/export?startDate=${startDate}&endDate=${endDate}&status=${status}`;
  } else if (startDate && endDate && status === "any") {
    fileUrl = `${config.transactions}/export?startDate=${startDate}&endDate=${endDate}`;
  } else {
    fileUrl = `${config.transactions}/export`;
  }

  return async (dispatch) => {
    axios({
      url: fileUrl,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `nutriasia-transactions-${yyyyMMddHHiiSS(now)}.csv`
      );
      document.body.appendChild(link);
      link.click();

      dispatch(fileExportSuccess(response.data));
    });
  };
};

/*  WINNER  */
export const onWinnersExport = (startDate, endDate, text) => {
  let fileUrl;

  if (!startDate && !endDate && text) {
    fileUrl = `${config.winners}/export?text=${text}`;
  } else if (!startDate && !endDate && !text) {
    fileUrl = `${config.winners}/export`;
  } else if (startDate && endDate && text) {
    fileUrl = `${config.winners}/export?startDate=${startDate}&endDate=${endDate}&text=${text}`;
  } else if (startDate && endDate) {
    fileUrl = `${config.winners}/export?startDate=${startDate}&endDate=${endDate}`;
  } else {
    fileUrl = `${config.winners}/export`;
  }
  return async (dispatch) => {
    axios({
      url: fileUrl,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `nutriasia-winner-${yyyyMMddHHiiSS(now)}.csv`);
      document.body.appendChild(link);
      link.click();

      dispatch(fileExportSuccess(response.data));
    });
  };
};

/* ENTRIES EXPORT */
export const onEntriesExport = (session, userRole) => {
  return async (dispatch) => {
    axios({
      url: `${config.prep}/export?session_id=${session}`,
      method: "GET",
      responseType: "blob",
      headers: {
        "x-user-role": userRole,
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `nutriasia-ticket-${yyyyMMddHHiiSS(now)}.csv`);
      document.body.appendChild(link);
      link.click();

      dispatch(fileExportSuccess(response.data));
    });
  };
};

/* DRAW EXPORT */
export const onRaffleDrawExport = (session, userRole) => {
  return async (dispatch) => {
    axios({
      url: `${config.raffle}/export?session_id=${session}`,
      method: "GET",
      responseType: "blob",
      headers: {
        "x-user-role": userRole,
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `nutriasia-winner-${yyyyMMddHHiiSS(now)}.csv`);
      document.body.appendChild(link);
      link.click();

      dispatch(fileExportSuccess(response.data));
    });
  };
};

// ADS EXPORT
export const onAdsExport = (startDate, endDate) => {
  let fileUrl;

  if (startDate && !endDate) {
    fileUrl = `${config.referrals}/export?startDate=${startDate}`;
  } else if (endDate && !startDate) {
    fileUrl = `${config.referrals}/export?endDate=${endDate}`;
  } else if (startDate && endDate) {
    fileUrl = `${config.referrals}/export?startDate=${startDate}&endDate=${endDate}`;
  } else {
    fileUrl = `${config.referrals}/export`;
  }

  return async (dispatch) => {
    axios({
      url: fileUrl,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `nutriasia-ads-report-${yyyyMMddHHiiSS(now)}.csv`
        );
        document.body.appendChild(link);
        link.click();

        dispatch(fileExportSuccess(response.data, "Success!"));
      })
      .catch((error) => {
        if (error.response && error.response.status === 500) {
          dispatch(fileExportError("Error!"));
        } else {
          dispatch(fileExportError("Error!"));
        }
      });
  };
};
